
























import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'

type StatusMessage = {
  mode: 'status'
  data: {
    type: 'login' | 'logout'
    message: string
    user: string // heartline id
  }
}

type CallMessage = {
  mode: 'call'
  data: {
    type: 'call_request' | 'finish'
    message: string
    from: string // heartline id
    id: string // 通話のID。たぶんJanusのやつかな？,
  }
}

// あと先考えずに命名してしまい後悔しています。変更してもらえると🙇‍♂️
type MessageMessage = {
  mode: 'message'
  data: {
    message: string
    from: string // heartline id
  }
}

type Message = StatusMessage | CallMessage | MessageMessage

// 送信する時の型
type CallStartSend = {
  mode: 'call'
  data: {
    type: 'call_request'
    to: string[] // かける相手のハートラインIDのリスト
  }
}

type CallFinishSend = {
  mode: 'call'
  data: {
    type: 'finish'
    callId: string // 通話のID。
  }
}

type MessageSend = {
  mode: 'message'
  data: {
    level: number // メッセージレベル。要確認
    type: string // メッセージタイプ。要確認
    content: string // メッセージの内容
    to: string[] // 宛先
  }
}

type SendMessage = CallStartSend | CallFinishSend | MessageSend

@Component
export default class Status extends Vue {
  $store!: ExStore
  client!: WebSocket
  logLog = ''
  patientId = 'pat1'
  callId: string | null = null
  message = ''

  get patientIds() {
    return this.patientId.split(',').map(v => v.trim())
  }

  created() {
    this.client = new WebSocket(`ws://localhost:8000/status/`)
    this.client.onmessage = e => {
      const data = JSON.parse(e.data) as Message
      console.log(data)
      if (data.mode === 'call') {
        this.logLog += '【通話】' + data.data.message + '\n'
        if (data.data.type === 'call_request') {
          this.callId = data.data.id
        } else {
          this.callId = null
        }
      } else if (data.mode === 'status') {
        this.logLog += '【状態】' + data.data.message + '\n'
        // const user = data.data.user
        if (data.data.type === 'login') {
          // ログインさせる
        } else {
          // ログアウトさせる
        }
      } else if (data.mode === 'message') {
        this.logLog +=
          '【メッセージ】' + data.data.from + '「' + data.data.message + '」\n'
      } else {
        this.logLog += '【その他】' + JSON.stringify(data) + '\n'
      }
    }

    this.client.onclose = () => {
      console.error('Chat socket closed unexpectedly')
    }
  }

  startCall() {
    if (this.callId) return
    const message: CallStartSend = {
      mode: 'call',
      data: {
        type: 'call_request',
        to: this.patientIds
      }
    }
    this.client.send(JSON.stringify(message))
  }

  sendMessage() {
    if (!this.message) return
    const message: MessageSend = {
      mode: 'message',
      data: {
        level: 1,
        type: 'greeting',
        content: this.message,
        to: this.patientIds
      }
    }
    this.client.send(JSON.stringify(message))
    this.message = ''
  }

  finishCall() {
    if (!this.callId) {
      return
    }
    const message: CallFinishSend = {
      mode: 'call',
      data: {
        type: 'finish',
        callId: this.callId
      }
    }
    this.client.send(JSON.stringify(message))
    this.callId = null
  }

  closeClient() {
    this.client.close()
  }
}
